import React, { useState, useEffect } from 'react';
const API_URL = process.env.REACT_APP_API_URL;


const EnvironmentList = () => {
    const [posts, setPosts] = useState([]);
    useEffect(() => {
        fetch(`${API_URL}/environments/`)
            .then((response) => response.json())
            .then((data) => {
                console.log(data);
                setPosts(data);
            })
            .catch((err) => {
                console.log(err.message);
            });
    }, []);

    return (
        <div className="EnvironmentList">
            <h2>List</h2>
            <ol>
                {posts.map((post) => {
                    return (<li key={post.id}>{post.name}</li>)
                })
                }

            </ol>
        </div>
    );
};
export default EnvironmentList;
